import { useContext, useEffect, useState } from "react";
import { Tab, Tabs } from "react-bootstrap";
import { useNavigate, useParams, Navigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

import PanelRightContent from "../../layouts/mainPanel/PanelRightContent";
import MainPanelHeader from "../../layouts/mainPanelHeader";
import MyItems from "../Food/MyItems";
import Food from "../Food/Food";
import TakingOrder from "../Food/takingOrder";
import MarketTab from "./MarketTab";
import OffersManagement from "./OffersManagement";
import { GlobalStateContext } from "../../layouts/GlobalStates";

import "../Food/style.scss";
import "./style.scss";

export const SHOP_TAB_KEY = "4";
export const OFFERS_TAB_KEY = "5";
const SERVICE_TAB_KEYS = ["1", "2", "3", OFFERS_TAB_KEY];

export function SalesAndServicesRedirect({ from }) {
  const { tab } = useParams();
  const safeTab = SERVICE_TAB_KEYS.includes(tab) ? tab : "1";

  if (from === "market") {
    return <Navigate to={`/dashboard/sales/1`} replace />;
  }

  return <Navigate to={`/dashboard/sales/${safeTab}`} replace />;
}

export default function SalesAndServices() {
  const { tab } = useParams();
  const history = useNavigate();
  const { t } = useTranslation();
  const { auth } = useContext(GlobalStateContext);
  const canManageOffers = Boolean(
    auth?.company_admin && auth?.package?.discount_permission
  );
  const initialTab = SERVICE_TAB_KEYS.includes(tab) ? tab : "1";
  const [activeTab, setActiveTab] = useState(initialTab);

  useEffect(() => {
    if (tab === SHOP_TAB_KEY || !SERVICE_TAB_KEYS.includes(tab)) {
      history("/dashboard/sales/1", { replace: true });
      setActiveTab("1");
      return;
    }
    if (tab === OFFERS_TAB_KEY && !canManageOffers) {
      history("/dashboard/sales/1", { replace: true });
      setActiveTab("1");
      return;
    }
    setActiveTab(tab);
  }, [tab, history, canManageOffers]);

  const activeTabHandle = (nextTab) => {
    if (!nextTab || nextTab === SHOP_TAB_KEY) {
      return;
    }
    history(`/dashboard/sales/${nextTab}`);
    setActiveTab(nextTab);
  };

  const sectionTitle = t("SalesAndServices.Label");

  return (
    <div className="food-main sales-and-services">
      <MainPanelHeader
        panelType={t("Corpration.Panel.label")}
        panelName={sectionTitle}
      />
      <div className="market-content">
        <PanelRightContent>
          <div className="tab-section">
            <Tabs
              activeKey={activeTab}
              transition={false}
              className="panel_tab sales-and-services__tabs"
              onSelect={activeTabHandle}
            >
              <Tab
                eventKey="1"
                className="panel_tab_item"
                title={t("Src.Pages.Food.index.Items")}
              />
              <Tab
                eventKey="2"
                className="panel_tab_item"
                title={t("Src.Pages.Food.index.Cart")}
              />
              <Tab
                eventKey="3"
                className="panel_tab_item"
                title={t("Organizational.Restaurant.TakingOrder.Tab")}
              />
              {canManageOffers && (
                <Tab
                  eventKey={OFFERS_TAB_KEY}
                  className="panel_tab_item"
                  title={t("offers.tab")}
                />
              )}
              <Tab
                eventKey={SHOP_TAB_KEY}
                className="panel_tab_item sales-and-services__shop-tab"
                disabled
                title={
                  <span className="sales-and-services__disabled-tab">
                    {t("SellingCart.Label")}
                    <span className="sales-and-services__soon-badge">
                      {t("SalesAndServices.Shop.ComingSoon")}
                    </span>
                  </span>
                }
              />
            </Tabs>
          </div>
          <div className="content-section">
            {activeTab === "1" && <MyItems />}
            {activeTab === "2" && <Food />}
            {activeTab === "3" && <TakingOrder />}
            {activeTab === OFFERS_TAB_KEY && canManageOffers && (
              <OffersManagement activeTab={activeTab} />
            )}
            {activeTab === SHOP_TAB_KEY && <MarketTab disabled />}
          </div>
        </PanelRightContent>
      </div>
    </div>
  );
}
